module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-228.9456f25b.svg";